import React from "react";
import MuiLink from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";

type CprimeLinkProps = React.ComponentProps<typeof MuiLink> & {
  to?: string;
  state?: any;
  component?: any;
  type?: string;
};

const CprimeLink: React.FC<CprimeLinkProps> = ({
  to,
  state,
  sx,
  underline = "hover",
  color = "inherit",
  ...props
}) => {
  if (to) {
    return (
      <MuiLink
        {...(props as any)}
        component={RouterLink as any}
        to={to}
        state={state}
        underline={underline}
        color={color}
        sx={{
          fontFamily: "ToyotaType-Regular",
          ...sx,
        }}
      />
    );
  }

  return (
    <MuiLink
      {...(props as any)}
      underline={underline}
      color={color}
      sx={{
        fontFamily: "ToyotaType-Regular",
        ...sx,
      }}
    />
  );
};

export default CprimeLink;
